import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { catchError, map, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { datadogLogs } from '@datadog/browser-logs';
import { isPlatformBrowser } from '@angular/common';
import { StandardResponseDto } from 'src/app/shared/dtos/standard-response.dto';

@Injectable({
  providedIn: 'root'
})
export class AppcoreService {
  private readonly httpClient = inject(HttpClient);
  private readonly ssrCookieService = inject(SsrCookieService);
  private readonly BUSINESS_PORTAL_AUTH_COOKIE_NAME = 'MYSAPSSO2';

  private sapCookie!: string;

  isAuthorised(): Observable<boolean> {
    if (!this.sapCookie) {
      this.sapCookie = this.ssrCookieService.get(this.BUSINESS_PORTAL_AUTH_COOKIE_NAME);
    }
    return this.getHeartbeat();
  }

  isAuthenticated(): Observable<boolean> {
    const isAuth = this.ssrCookieService.get('isAuth');
    this.sapCookie = this.ssrCookieService.get(this.BUSINESS_PORTAL_AUTH_COOKIE_NAME);

    if (isAuth) {
      return of(true);
    }

    return of(false);
  }

  getHeartbeat(): Observable<boolean> {
    return this.httpClient.get(`/api/heartbeat`, {
      headers: {
        'SAPCookie': this.sapCookie ? encodeURIComponent(this.sapCookie) : ''
      }
    }).pipe(
      catchError((error: Error) => {
        if (isPlatformBrowser(PLATFORM_ID)) {
          datadogLogs.logger.error('Error fetching heartbeat:', {}, error);
        }
        return of(new StandardResponseDto());
      }),
      map((response: StandardResponseDto) => {
        return response.Status === 'ok';
      })
    );
  }
}
